import { ref } from 'vue'

// Module-level singleton — shared across the entire app,
// importable from Vue components and plain TS modules alike.
const isLoading = ref(false)

export function useGlobalLoading() {
  function showGlobalLoading() {
    isLoading.value = true
  }

  function hideGlobalLoading() {
    isLoading.value = false
  }

  return { isLoading, showGlobalLoading, hideGlobalLoading }
}
